import React, {Component} from 'react'
import './Footer.css'
// eslint-disable-next-line
import { BrowserRouter as Router, Route, NavLink } from 'react-router-dom'

class Footer extends Component {
	render(){
		let d = new Date()
		return (
			<div className="footer-container">

				<div className="footer-container-mobile">
					<div className="footer-logo"></div><br />
					<br />
					Call <a href="tel:07703502505">07703 502505</a> for a FREE estimate!<br />
					<br /><br />
					<a href="https://www.facebook.com/FairyClean1">
						<div className="fb-logo-m"></div><br />
						Visit us on FACEBOOK
					</a><br />
					<br /><br />
					© {d.getFullYear()} Fairy Clean<br />
					London<br />
					<br /><br />
					Made in <a href="http://www.magicislands.co.uk" target="_blank" rel="noopener noreferrer">Magic Islands</a>
				</div>

				<div className="footer-container-desktop">

					<div className="footer-section-1">
					<div className="footer-logo"></div><br/>
					Call <a href="tel:07703502505">07703 502505</a> for a FREE estimate!<br />
					<br />
					<a href="https://www.facebook.com/FairyClean1" target="_blank" rel="noopener noreferrer">
						<div className="fb-logo"></div>
						Visit us on FACEBOOK
					</a><br />

					<div className="footer-section-1-copyright">
						© {d.getFullYear()} Fairy Clean<br />
						London<br />
						<br />
						Made in <a href="http://www.magicislands.co.uk" target="_blank" rel="noopener noreferrer">Magic Islands</a>
					</div>

					</div>

					<div className="footer-section-2">

						<NavLink exact to="/about">

							<strong>Locations</strong><br /><br />

							<ul>
								<li>Barnet</li>
								<li>Borehamwood</li>
								<li>Cockfosters</li>
								<li>Colindale</li>
								<li>Edgware</li>
								<li>Enfield</li>
								<li>Finchley</li>
								<li>Hadley Wood</li>
								<li>Hampstead</li>
								<li>Hendon</li>
								<li>Mill Hill</li>
								<li>Oakwood</li>
								<li>Palmers Green</li>
								<li>Southgate</li>
								<li>Stanmore</li>
								<li>Whetstone</li>
								<li>Winchmore Hill</li>
								<li>Wood Green</li>
							</ul>

						</NavLink>

					</div>

					<div className="footer-section-3">

						<NavLink exact to="/services">

							<strong>Cleaning Services</strong><br /><br />

							<ul>
								<li>Domestic</li>
								<li>Deep Spring</li>
								<li>One-Off</li>
								<li>End of Tenancy</li>
								<li>Move In/Out</li>
								<li>Party</li>
							</ul>

						</NavLink>

					</div>

				</div>

			</div>
		)
	}
}

export default Footer


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js